import React, { useEffect, useState } from "react";
import RelationshipDrawer from "./RelationshipDrawer";
import CommonTextArea from "@/shared/components/ui/Input/CommonTextArea";
import CommonDatePicker from "@/shared/components/ui/DatePicker/CommonDatePicker";
import CommonSelect from "@/shared/components/ui/Select/CommonSelect";
import { TOUCH_POINT_TYPE_OPTIONS } from "@/shared/utils/accountConfig";

const NoteEditorDrawer = ({
  isOpen,
  onClose,
  noteToEdit = null,
  isSaving = false,
  onSave,
}) => {
  const [touchPointType, setTouchPointType] = useState("call");
  const [touchPointDate, setTouchPointDate] = useState(null);
  const [body, setBody] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setTouchPointType(noteToEdit?.touch_point_type || "call");
    setTouchPointDate(noteToEdit?.touch_point_date || null);
    setBody(noteToEdit?.body || "");
  }, [isOpen, noteToEdit]);

  const isEditing = Boolean(noteToEdit);

  return (
    <RelationshipDrawer
      isOpen={isOpen}
      onClose={onClose}
      drawerType="notes"
      title={isEditing ? "Edit Note" : "Take Note"}
      description={
        isEditing
          ? "Update the interaction details and note"
          : "Record an interaction or important deal update"
      }
      primaryButtonText={isEditing ? "Update Note" : "Save Note"}
      secondaryButtonText="Cancel"
      isPrimaryLoading={isSaving}
      isPrimaryDisabled={isSaving || !body.trim()}
      isSecondaryDisabled={isSaving}
      onPrimaryClick={() =>
        onSave({
          body,
          touch_point_type: touchPointType,
          touch_point_date: touchPointDate,
        })
      }
    >
      <div className="flex gap-3">
        <div className="flex flex-col gap-2">
          <h5 className="font-[Inter] text-xs font-medium text-gray-500 dark:text-gray-400">
            Touch Point Type
          </h5>
          <CommonSelect
            options={TOUCH_POINT_TYPE_OPTIONS}
            value={touchPointType}
            onChange={setTouchPointType}
            classNames={{
              value: "!text-gray-800 dark:!text-gray-100 font-inter !font-medium !text-[0.715rem]",
            }}
          />
        </div>

        <div className="flex w-full flex-col gap-2">
          <h5 className="font-[Inter] text-xs font-medium text-gray-500 dark:text-gray-400">
            Date
          </h5>
          <CommonDatePicker
            value={touchPointDate}
            onChange={setTouchPointDate}
            className="h-9"
          />
        </div>
      </div>

      <div className="flex w-full flex-col gap-2">
        <h5 className="font-[Inter] text-xs font-medium text-gray-500 dark:text-gray-400">
          Notes
        </h5>
        <CommonTextArea
          placeholder="What happened? Add responses, commitments, or next steps..."
          rows={5}
          value={body}
          onChange={(event) => setBody(event.target.value)}
          disabled={isSaving}
          className="disabled:cursor-not-allowed disabled:opacity-100"
        />
      </div>
    </RelationshipDrawer>
  );
};

export default NoteEditorDrawer;

